module.exports = __webpack_public_path__ + "img/icon_cyberblade_app.97716598.svg";